<template>
  <div :class="$style['pt-holiday-excel-new']">
    <pt-page-title title="批量导入节假日">
      <el-button type="primary" plain slot="on-right"  style="margin-left:20px" @click="goNew">创建单个节假日
      </el-button>
    </pt-page-title>
    <pt-sub-title title="批量导入"></pt-sub-title>
    <holiday-excel-form ref="form"></holiday-excel-form>
    <div :class="$style.btns">
      <el-button type="primary" v-intervalclick="{func:createLot,time:500}">立即创建</el-button>
			<el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import holidayExcelForm from './form'
// 组件class前缀
const prefixCls = 'pt-holiday-excel-new'

export default {
  name: 'pt-holiday-excel-new',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    holidayExcelForm
  },
  methods: {
    goNew () {
      this.$router.push(`/holiday-manage/${this.$route.meta.type}/holiday-form/false/0`)
    },
    createLot () {
      this.$refs.form.validate().then(formValue => {
        this.$refs.form.submit()
      })
    },
    cancel () {
      history.go(-1)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-holiday-excel-new .btns{
  margin-top:20px;
}
</style>
